import { useTranslation } from '@mint-lib/i18n';
import { AiStarFilled } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import useAgenticModal from '../../../hooks/useAgenticModal.js';

const AgenticAiButton = () => {
  const { t } = useTranslation('@mint-lib/agentic-ai-circuit');
  const { setIsChatManuallyActive } = useAgenticModal();
  const onClick = () => {
    setIsChatManuallyActive(true);
  };

  return (
    <div className="inline-block rounded-sm bg-gradient-to-tr from-ai-lightCyan to-ai-lightGreen p-px">
      <Button
        onClick={onClick}
        aria-label="agentic-ai-button"
        size="medium"
        className={cn(
          'w-29.5 rounded-sm bg-ui-primary px-3 text-secondary-dark hover:bg-ui-primary',
          'focus:outline-none active:bg-ui-primary', // disable default button behavior
        )}
      >
        <AiStarFilled className={'fill-icon-primary'} />
        {t('Agentic AI')}
      </Button>
    </div>
  );
};
export default AgenticAiButton;
